import React from "react";
import { NavLink } from "react-router-dom";

class Navigation extends React.Component {
  componentDidMount() {
    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var script = document.createElement("script");
        script.src = src;
        script.addEventListener("load", function () {
          resolve();
        });
        script.addEventListener("error", function (e) {
          reject(e);
        });
        document.body.appendChild(script);
        document.body.removeChild(script);
      });
    }

    loadScript("./assets/js/mobilenav.js");

    // Setup Gallery click handler
    this.setupGalleryClick();
  }

  setupGalleryClick = () => {
    // Wait for DOM to be ready
    setTimeout(() => {
      const galleryLink = document.querySelector('.has-child > a[href="#"]');
      if (galleryLink && window.jQuery) {
        const $ = window.jQuery;

        // Remove any existing handlers
        $(galleryLink).off("click.gallery");

        // Add click handler
        $(galleryLink).on("click.gallery", function (ev) {
          // Only work in mobile view
          if (window.innerWidth > 768) {
            return;
          }

          ev.preventDefault();
          ev.stopPropagation();

          const $parent = $(this).parent();
          const $submenu = $parent.find(".sub-menu").first();

          // Close other submenus
          $parent.siblings(".has-child").each(function () {
            $(this)
              .find(".sub-menu")
              .slideUp(500, function () {
                $(this).parent().removeClass("nav-active");
              });
          });

          // Toggle current submenu
          $submenu.slideToggle(500, function () {
            $parent.toggleClass("nav-active");
          });
        });
      }
    }, 500);
  };

  render() {
    const { isLoggedIn, userRole } = this.props;
    return (
      <>
        <ul className="nav navbar-nav">
          {/* Mobile drawer items - Mail, Call, Login, Register */}

          <li className="active">
            <NavLink to={"/"}>Home</NavLink>
            {/* <ul className="sub-menu">
                            <li><NavLink to={"/"}>Home-1</NavLink></li>
                            <li><NavLink to={"/home-2"}>Home-2</NavLink></li>
                            <li><NavLink to={"/home-3"}>Home-3</NavLink></li>
                            <li><NavLink to={"/home-4"}>Home-4</NavLink></li>
                            <li><NavLink to={"/home-5"}>Home-5</NavLink></li>
                            <li><NavLink to={"/home-6"}>Home-6</NavLink></li>
                        </ul> */}
          </li>
          <li>
            <NavLink to={"/about-us"}>About us</NavLink>
            {/* <ul className="sub-menu">
                            <li><NavLink to={"/about-1"}>About 1</NavLink></li>
                            <li><NavLink to={"/about-2"}>About 2</NavLink></li>
                        </ul> */}
          </li>
          <li>
            <NavLink to={"/services"}>Services</NavLink>
            <ul className="sub-menu">
              <li>
                <NavLink to={"/architecture-design"} state={{ id: 5 }}>
                  Architectural Design
                </NavLink>
              </li>
              <li>
                <NavLink to={"/interior-design"} state={{ id: 6 }}>
                  Interior Design & Execution
                </NavLink>
              </li>
              <li>
                <NavLink to={"/turnkey-construction"} state={{ id: 8 }}>
                  Turnkey Construction
                </NavLink>
              </li>
            </ul>
            {/* <ul className="sub-menu">
                            <li>
                                <NavLink to={""}>Services</NavLink>
                                <ul className="sub-menu">
                                    <li><NavLink to={"/services-1"}>Services 1</NavLink></li>
                                    <li><NavLink to={"/services-2"}>Services 2</NavLink></li>
                                    <li><NavLink to={"/services-detail"}>Service Detail</NavLink></li>
                                </ul>
                            </li>
                            <li>
                                <NavLink to={""}>Team</NavLink>
                                <ul className="sub-menu">
                                    <li><NavLink to={"/team-1"}>Our Team 1</NavLink></li>
                                    <li><NavLink to={"/team-2"}>Our Team 2</NavLink></li>
                                    <li><NavLink to={"/team-single"}>Team Detail</NavLink></li>
                                </ul>
                            </li>
                            <li><NavLink to={"/our-history"}>Our History</NavLink></li>
                            <li><NavLink to={"/icon-font"}>Fonts Icons</NavLink></li>
                            <li><NavLink to={"/error-404"}>Error 404</NavLink></li>
                        </ul> */}
          </li>
          <li>
            <NavLink
              to="#"
              onClick={(e) => {
                // Only work in mobile view
                if (window.innerWidth > 768) {
                  return;
                }

                e.preventDefault();
                e.stopPropagation();

                if (window.jQuery) {
                  const $ = window.jQuery;
                  const $parent = $(e.currentTarget).parent();
                  const $submenu = $parent.find(".sub-menu").first();

                  // Close other submenus
                  $parent.siblings(".has-child").each(function () {
                    $(this)
                      .find(".sub-menu")
                      .slideUp(500, function () {
                        $(this).parent().removeClass("nav-active");
                      });
                  });

                  // Toggle current submenu
                  $submenu.slideToggle(500, function () {
                    $parent.toggleClass("nav-active");
                  });
                }
              }}
            >
              Gallery
            </NavLink>
            <ul className="sub-menu">
              <li>
                <NavLink to={"/project-grid-5-columns"}>Showcase</NavLink>
                {/* <ul className="sub-menu">
                                    <li><NavLink to={"/project-grid-3-columns"}>3 Columns</NavLink></li>
                                    <li><NavLink to={"/project-grid-3-columns-no-gap"}>3 Columns No Gutter</NavLink></li>
                                    <li><NavLink to={"/project-grid-4-columns"}>4 Columns</NavLink></li>
                                    <li><NavLink to={"/project-grid-4-columns-no-gap"}>4 Columns No Gutter</NavLink></li>
                                    <li><NavLink to={"/project-grid-5-columns"}>5 Columns</NavLink></li>
                                    <li><NavLink to={"/project-grid-5-columns-no-gap"}>5 Columns No Gutter</NavLink></li>
                                </ul> */}
              </li>
              <li>
                <NavLink to={"/infrio-choice"}>Infrio Choice</NavLink>
                {/* <ul className="sub-menu">
                                    <li><NavLink to={"/project-masonry-3-columns"}>3 Columns</NavLink></li>
                                    <li><NavLink to={"/project-masonry-3-columns-no-gap"}>3 Columns No Gutter</NavLink></li>
                                    <li><NavLink to={"/project-masonry-4-columns"}>4 Columns</NavLink></li>
                                    <li><NavLink to={"/project-masonry-4-columns-no-gap"}>4 Columns No Gutter</NavLink></li>
                                    <li><NavLink to={"/project-masonry-5-columns"}>5 Columns</NavLink></li>
                                    <li><NavLink to={"/project-masonry-5-columns-no-gap"}>5 Columns No Gutter</NavLink></li>
                                </ul> */}
              </li>
              {/* <li><NavLink to={"/project-carousel"}>Project Carousel</NavLink></li>
                            <li><NavLink to={""}>Project Detail</NavLink>
                                <ul className="sub-menu">
                                    <li><NavLink to={"/project-detail1"}>Project Detail 1</NavLink></li>
                                    <li><NavLink to={"/project-detail2"}>Project Detail 2</NavLink></li>
                                </ul>
                            </li> */}
            </ul>
          </li>
          <li>
            <NavLink to="#" aria-haspopup="true">
              Social
            </NavLink>
            <ul className="sub-menu">
              <li>
                <NavLink to={"/blog"}>Blog</NavLink>
              </li>
              <li>
                <NavLink to={"/social-media"}>Vlog</NavLink>
              </li>
            </ul>
          </li>
          {/* <li>
                        <NavLink to={""}>Shop</NavLink>
                        <ul className="sub-menu">
                            <li><NavLink to={"/shop-grid"}>Shop Grid</NavLink></li>
                            <li><NavLink to={"/shop-list"}>Shop List</NavLink></li>
                            <li><NavLink to={"/shop-detail"}>Shop Detail</NavLink></li>
                            <li><NavLink to={"/shop-account"}>My Account</NavLink></li>
                            <li><NavLink to={"/shop-cart"}>Cart</NavLink></li>
                            <li><NavLink to={"/shop-checkout"}>Checkout</NavLink></li>
                        </ul>
                    </li> */}
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={"https://www.solar.infrioindia.com/"}
              className="text-white"
              style={{
                textDecoration: "none",
                fontWeight: 500,
                fontSize: "15px",
              }}
            >
              Infrio Solar
            </a>
          </li>
          <li>
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={"https://www.property.infrioindia.com/"}
              className="text-white"
              style={{
                textDecoration: "none",
                fontWeight: 500,
                fontSize: "15px",
              }}
            >
              Infrio Properties
            </a>
          </li>
          <li>
            <NavLink to={"/contact-us"}>Contact us</NavLink>
          </li>
          {!isLoggedIn && (
            <>
              <li className="mobile-drawer-top-items">
                <NavLink to="/login">Login</NavLink>
              </li>
              <li className="mobile-drawer-top-items">
                <NavLink to="/register">Register</NavLink>
              </li>

              {/* <li className="mobile-drawer-top-items">
                                <NavLink to="/register" state={{ role: 'partner' }}>Become a Partner</NavLink>
                            </li> */}
            </>
          )}
          {isLoggedIn && (
            <li className="mobile-drawer-top-items">
              <NavLink
                to={
                  userRole === "normal" ? "/user-account" : "/partner-account"
                }
              >
                My Account
              </NavLink>
            </li>
          )}
          <li className="mobile-drawer-top-items">
            <a href="mailto:info@infrioindia.com">
              Mail Us : info@infrioindia.com
            </a>
          </li>
          <li className="mobile-drawer-top-items">
            <a href="tel:+919001457000">Call Us : +91 90014 57000</a>
          </li>
        </ul>
      </>
    );
  }
}

export default Navigation;
